/* 
Generated code: do not modify this file as it will be overwritten
Template: ImmutableJSRecord.cst

Known Issues/TODO:
- Using *Props type as Record constructor parameter is insufficient.
If a property needs to be a Record type, it should already be constructed.
- Rename Record fromJS factory method to fromJSON
- Create parseJSON method that translates JSON to Props



 */

/* eslint-disable import/order */

import { createSelector } from '@ngrx/store';
import { List, Map, Record, Seq, Set } from 'immutable';
import { AppState } from 'src/store/appstate';
import { getFromOrThrow, propValueOrDefault, tryOrDefault } from 'src/util/values';

export interface EngineParametersProps {
  time: number | null;
  starts: number | null;
}

export class EngineParametersRecord extends Record<EngineParametersProps>({
  time: null as any,
  starts: null as any,
}) {
  public static fromJS(json: {
    time: number | null;
    starts: number | null;
  }): EngineParametersRecord {
    if (json == null) {
      throw new Error('EngineParametersRecord.fromJS: parameter cannot be null');
    }
    return new EngineParametersRecord({
      time: json.time,
      starts: json.starts,
    });
  }

  public static fromJSUnsafe(json: {
    time: number | null;
    starts: number | null;
  }): [EngineParametersRecord, Error[]] {
    if (json == null) {
      throw new Error('EngineParametersRecord.fromJSUnsafe: parameter cannot be null');
    }
    const errors: Error[] = [];

    const record = new EngineParametersRecord({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      time: tryOrDefault(
        () => json.time,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      starts: tryOrDefault(
        () => json.starts,
        (err) => errors.push(err),
      )!,
    });

    return [record, errors];
  }

  constructor(props: EngineParametersProps) {
    super(props);
    if (props == null) {
      throw new Error('EngineParametersRecord constructor parameter cannot be null');
    }
  }
}

export abstract class EngineParametersViewModelBase implements EngineParametersProps {
  protected readonly _props: EngineParametersProps;
  private _json?: EngineParametersProps;

  get time(): number | null {
    return this._props.time;
  }
  get starts(): number | null {
    return this._props.starts;
  }

  constructor(props: EngineParametersProps) {
    this._props = props;
  }

  public toJS() {
    return this.toJSON();
  }

  public toJSON() {
    if (this._json == null) {
      this._json = {
        time: this._props.time,
        starts: this._props.starts,
      };
    }
    return this._json;
  }
}
